document.addEventListener('DOMContentLoaded', () => {
    const translationTimer = setInterval(() => {
        const currentUrl = window.location.href;
        const topBar = document.getElementsByClassName("fsb_msg_inner")[0];
        
        if (!topBar) return;

        clearInterval(translationTimer);

        const barText = topBar.textContent.trim();
        console.log('Top bar found! Translating now...', currentUrl, barText);

        if (currentUrl.includes('/en')) {
            if (barText === "Iscriviti alla newsletter per accedere allo sconto di benvenuto del 10%!") {
                topBar.textContent = "Sign up for our newsletter to get your 10% welcome discount!";
            } else if (barText === "Congratulazioni, hai ottenuto lo sconto!") {
                topBar.textContent = "Congratulations, you got your discount!";
            }
        } else if (currentUrl.includes('/de')) {
            if (barText === "Iscriviti alla newsletter per accedere allo sconto di benvenuto del 10%!") {
                topBar.textContent = "Melde dich für den Newsletter an und sichere dir deinen Willkommensrabatt von 10%!";
            } else if (barText === "Congratulazioni, hai ottenuto lo sconto!") { 
                topBar.textContent = "Herzlichen Glückwunsch, du hast deinen Rabatt erhalten!";
            }
        } else if (currentUrl.includes('/fr')) {
            if (barText === "Iscriviti alla newsletter per accedere allo sconto di benvenuto del 10%!") {
                topBar.textContent = "Inscrivez-vous à la newsletter pour bénéficier de votre remise de bienvenue de 10 % !";
            } else if (barText === "Congratulazioni, hai ottenuto lo sconto!") { 
                topBar.textContent = "Félicitations, vous avez obtenu votre réduction !";
            }
        }
    }, 200);
});